import { render, staticRenderFns } from "./showQuestions.vue?vue&type=template&id=42791dc7&scoped=true&"
import script from "./showQuestions.vue?vue&type=script&lang=js&"
export * from "./showQuestions.vue?vue&type=script&lang=js&"
import style0 from "./showQuestions.vue?vue&type=style&index=0&id=42791dc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42791dc7",
  null
  
)

export default component.exports